export default __webpack_public_path__ + "static/media/553ac76a-732e-4f41-b410-a18a06722cf1-hover.83bcc88c.svg";